import * as React from "react";

import "./breakdown-table.scss";

import {cs}             from "@Common/react/chain-services";
import {formatMoney1}   from "@Common/ui-components/language/format-money";
import {InformationBadge} from "@Common/ui-components/heavy/common/design2/information-badge/information-badge";

export const BreakdownTable = ({sections, rdfDescription}:{
    sections    : Array<{label: string, value: number}>[],
    rdfDescription?: string,
}) => cs(
    () => (
        <div className="breakdown-table breakdown-table-49i">
            {sections.map((section, k) => (
                <div className="section" key={k}>
                    {section.map((line, j) => (
                        <div className="line" key={j}>
                            <div className="label">
                                {line.label}
                                {rdfDescription && ( !["Total", "Sub Total", "Shipping Charge", "Handling Fee", "Sales Tax", "Vat Tax", "Import Duties"].includes(line.label) ) &&
                                    (<span style={{marginLeft: "5px"}}>
                                        {InformationBadge({
                                            getTooltip: () => rdfDescription,
                                            xdQaName: "RDF",
                                        })}
                                    </span>)
                                }
                                {line.label === "Vat Tax" && (
                                    <span style={{marginLeft: "5px"}}>
                                        {InformationBadge({
                                            getTooltip: () => "For your convenience, duties and taxes required for customs clearance are collected at checkout",
                                            xdQaName: "VAT",
                                        })}
                                    </span>
                                )}
                            </div>
                            <div className="value" xd-qa-type="label" xd-qa-name={line.label}>
                                {formatMoney1(line.value)}
                            </div>
                        </div>
                    ))}
                </div>
            ))}
        </div>
    ),
);

